// extracted by mini-css-extract-plugin
module.exports = {"grid":"Team_grid__2iHOf","card":"Team_card__3yUlx","name":"Team_name__2Tc-u","avatar":"Team_avatar__2o8oe"};